<template>
  <div class="container py-4">
    <template v-if="! loading">
      <h1 :class="`mb-2 ${loading ? 'skeleton skeleton-text text-h1' : ''}`">
        {{ course.title }}
      </h1>
      <div class="card" v-if="step == 0">
        <div v-if="loading" class="card-body">
          <p class="skeleton skeleton-text"></p>
          <p class="skeleton skeleton-text"></p>
          <p class="skeleton skeleton-text"></p>
          <p class="skeleton skeleton-text"></p>
        </div>
        <div class="card-body" v-if="!loading">
          <h2>Instructions</h2>
          <ol>
            <li>Complete this exam to proceed to the next course</li>
            <li>
              There are <strong>{{ questions.length }} questions</strong>
            </li>
            <li>
              You will need to answer at least
              <strong>{{ course.pass_mark }} correctly</strong>
            </li>
            <li>You can retake this exam multiple times.</li>
          </ol>
          <a href="#" class="btn btn-primary mt-4" @click.prevent="step = 1"
            >Begin Now</a
          >
        </div>
      </div>
      <div class="card" v-if="step == 1">
        <div v-for="(question, i) in questions" :key="`question-${i}`">
          <div class="card-body" v-if="i == show_question">
            <h2>{{ i + 1 }}. {{ question.content }}</h2>
            <div class="row">
              <div
                class="col-6"
                v-for="(option, j) in question.options"
                :key="`option-${j}`"
              >
                <input
                  type="radio"
                  class="mr-2"
                  :id="`question-${i}-${j}`"
                  v-model="question.selected_option"
                  :value="option.id"
                  name="question"
                />
                <label :for="`question-${i}-${j}`">{{ option.content }}</label>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <a
                  href="#"
                  class="btn btn-primary btn-sm"
                  @click.prevent="show_question--"
                  v-if="show_question > 0"
                  >Previous</a
                >
                <a
                  href="#"
                  class="btn btn-primary btn-sm"
                  @click.prevent="step = 0"
                  v-if="show_question == 0"
                  >Back</a
                >
              </div>
              <div class="col-6 text-right">
                <a
                  href="#"
                  class="btn btn-primary btn-sm"
                  @click.prevent="show_question++"
                  v-if="show_question < questions.length - 1"
                  >Next</a
                >
                <a
                  href="#"
                  class="btn btn-primary btn-sm"
                  @click.prevent="markExam()"
                  v-if="show_question == questions.length - 1"
                  >Complete</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="step == 2">
        <div class="card-body">
          <h2>Your results</h2>
          <div v-if="!completed">
            <img src="/loader.gif" alt="loading" />
          </div>
          <div v-if="completed">
            <div v-if="results.passed">
              <div class="alert alert-success">
                <h3>You Passed</h3>
                <h3>{{ results.score }}%</h3>
              </div>
              <a
                :href="$router.resolve({ name: 'trader.community' }).href"
                class="btn btn-primary"
                >Join the community</a
              >
            </div>
            <div v-if="!results.passed">
              <div class="alert alert-danger">
                <h3>You Failed</h3>
                <h3>{{ results.score }}%</h3>
              </div>
              <router-link
                :to="{ name: 'trader.academy.start' }"
                class="btn btn-primary"
                >Review Videos</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      course: {},
      questions: [],
      step: 0,
      show_question: 0,
      results: {},
      completed: false,
      loading: true,
    };
  },

  methods: {
    fetch() {
      this.loading = true;
      this.$axios.get("/api/v1/trader/academy/exam").then((response) => {
        if(! response.data.exam) {
          window.location.href = this.$router.resolve({ name: 'trader.academy' }).href
        } else {
          this.course = response.data.course;
          this.questions = response.data.questions;
          this.loading = false;
        }
      });
    },

    markExam() {
      this.step = 2;
      this.completed = false;

      let data = this.questions.map((question) => {
        return {
          question_id: question.id,
          option_id: question.selected_option,
        };
      });

      this.$axios.post("/api/v1/trader/academy/exam", data).then((response) => {
        this.results = response.data.results;
        this.completed = true;
      });
    },
  },
};
</script>
